import BrandInput from "@/widgets/Inputs/BrandInput.vue";
import ClassifyInput from "@/widgets/Inputs/ClassifyInput.vue";
import ProductInput from "@/widgets/Inputs/ProductInput.vue";
import ItemsMatrix from "@/widgets/ItemsMatrix.vue";
import CurdTable from "@/components/CurdTable.vue";
import WarehouseInput from "@/widgets/Inputs/WarehouseInput.vue";

export default {
	components: {
		ProductInput,
		ItemsMatrix,
		ClassifyInput,
		BrandInput,
		CurdTable,
		WarehouseInput
	},
	data() {
		return {
			loadings: {
				insert: false,
			},
			recordId: "",
			formItem: {
				price_per: 0,
				_id: "",
			},
			brand: {
				name: "",
				_id: "",
			},
			warehouse: {
				name: "",
				_id: "",
			},
			classify: [],
			products: [],
			product_color: {
				name: "",
				_id: "",
				filter: [
					{
						name: "brand",
						value: "",
					},
				],
				colors: [],
				models: [],
				brand: {
					name: "",
					_id: "",
				},
				classify: {
					name: "",
					_id: "",
				},
				price_0: "",
				price_1: 0,
				price_2: 0,
				price_3: 0,
				price_4: 0,
				price_5: 0,
				cost_per: 0,
			},
			stocks: [],
			filterTableSearch: "",
		};
	},
	computed: {
		productFilters() {
			let filter = {};
			if (this.brand._id != "") {
				filter.brand = { k: "brand", t: "_id", v: this.brand._id };
			}
			if (this.classify.length != 0) {
				filter.classify = {
					k: "classify",
					t: "classify",
					v: this.classify[this.classify.length - 1]._id,
				};
			}
			if (this.warehouse._id != "") {
				filter.warehouse = { k: "warehouse", t: "_id", v: this.warehouse._id };
			}
			return filter;
		},
	},
	props: {
		warehouseId: {
			type: String,
			default: "",
		},
		isNeedCost: {
			type: Boolean,
			default: false,
		},
		isUsePrice: {
			type: Boolean,
			default: false,
		},
		agentLevel: {
			type: Object,
			default: () => {
				return {
					index: 0,
					name: "代理",
				};
			},
		},
		order: {
			type: Object,
			default: () => {
				return {
					_id: "",
					name: "",
				};
			},
		},
	},
	methods: {
		handleFilterProduct() {},
		handleChoose(row) {
			this.product_color = JSON.parse(JSON.stringify(row));
		},
		handleResetClear() {
			this.$refs["itemsMatrix"].handleResetClear();
		},
		handleResetProduct() {
			this.product_color = {
				name: "",
				_id: "",
				filter: [
					{
						name: "brand",
						value: "",
					},
				],
				colors: [],
				models: [],
				brand: {
					name: "",
					_id: "",
				},
				classify: {
					name: "",
					_id: "",
				},
				warehouse: {
					name: "",
					_id: "",
				},
				price_0: "",
				price_1: 0,
				price_2: 0,
				price_3: 0,
				price_4: 0,
				price_5: 0,
				cost_per: 0,
			};
			this.$refs["insertForm"].resetFields();
		},
		handleInsert(items, type) {
			console.log("items:",items)
			const types = type || 0
			if(types == 1){
				if (!this.stocks.length) {
					this.stocks.push({amount: 1,inPreSale: 0,inSell: 0,oldAmount: 0,_id: items._id,info:items})
				}
				this.$refs["insertForm"].validate(valid => {
					if (!valid) {
						return false;
					}
					items.price_per = items.price_1;
					console.log('单价',items)
					this.product_color = items
					this.product_color._id = items.product_color._id


					console.log(this.product_color)
					this._doInsert(this.product_color, 1);
				});
				this.stocks = []
			}else{
				if (!this.stocks.length) {
					this.$message.error("数量未填写！");
					return;
				}
				this.$refs["insertForm"].validate(valid => {
					if (!valid) {
						return false;
					}
					this._doInsert(this.product_color);
				});
			}

			// if (!this.stocks.length) {
			// 	this.$message.error("数量未填写！");
			// 	return;
			// }
			// if (!this.stocks.length) {
			// 	this.stocks.push({amount: 1,inPreSale: 0,inSell: 0,oldAmount: 0,_id: items._id,info:items})
			// }
			// this.$refs["insertForm"].validate(valid => {
			// 	if (!valid) {
			// 		return false;
			// 	}
				// this._doInsert(this.product_color);
				// this._doInsert(items);
			// });
		},
	},
};
